<template>
  <div :class="mode==='grid' ? 'grid' : 'list'" v-if="this.shouldBeVisible">
    <draggable :forceFallback="true" v-model="rentalsList" group="image" @start="drag=true" @change="reorder" :sort="true" class="rentals-content" :class="mode==='grid' ? 'grid-view': 'list-view'">
      <div class="rental-item" v-for="rental in rentalsList" @click.prevent="$emit('edit', rental.id)">
        <div class="main-content">
          <div class="rental-status">
            <span class="status" :class="{active: rental.status}">{{ rental.status ? $t("rentals.status.listed") : $t("rentals.status.not_listed") }}</span>
          </div>
          <div class="rental-image">
            <div class="visuel-wrapper" :class="mode==='grid' ? 'resp-img-box' : 'resp-img-list'">
              <img
                :src="(rental.photos.length > 0) ? rental.photos[0].name : '/static/assets/images/SuperHote_icons/rent.png'"
                alt="" class="img-responsive" :class="(rental.photos.length <= 0) ?'default-rent' : '' ">

              <div v-if="mode==='grid'" class="rentals-image-masque">
                <router-link :to="{ name: 'rentals.detail', params: { id: rental.id } }" class="btn btn-block btn-warning waves-effect waves-classic waves-effect waves-classic">
                  {{ $t("button.edit") }}
                </router-link>
              </div>
            </div>
          </div>
          <div class="rental-name">
            <div class="name">{{ rental.name }}</div>
            <div style="text-align:center;" v-if="rental.airbnb_account != null" title="Airbnb">{{ rental.airbnb_account.username }}</div>
          </div>
        </div>
      </div>
    </draggable>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import rentalService from './../../../services/rental';

export default {
  name: 'RentalItemBlock',
  props: ['mode', 'rentals'],

  components: {
    draggable,
  },

  data() {
    return {
      rentalsList: [],
      shouldBeVisible: this.mode !== 'group',
    };
  },

  mounted() {
    this.rentalsList = this.rentals;
  },
  methods: {
    reorder() {
      const data = {};
      this.rentalsList.forEach((item, index) => {
        data[item.id] = index;
        item.order = index;
      });

      rentalService.updateRentalsOrder(data, this);
    },
  },

  watch: {
    rentals(newVal) {
      if (newVal) {
        this.rentalsList = newVal;
      }
    },

    mode(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.shouldBeVisible = newVal !== 'group';
      }
    },
  },


};
</script>



// WEBPACK FOOTER //
// RentalItemBlock.vue?ee7bfb96